import React, { useState, useRef, useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import NewHeader from "../Header/NewHeader";
import NewFooter from "../Footer/NewFooter";
import Typewriter from "typewriter-effect";
import { API_URL } from "../../Config";

gsap.registerPlugin(ScrollTrigger);
const toYMD = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const BookNow = () => {
  // CALENDAR STATE
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDates, setSelectedDates] = useState([]);
  const [blockedDates, setBlockedDates] = useState([]);
  // GUEST DETAILS FORM STATE
  const [nightlyPrices, setNightlyPrices] = useState([]);
  const [discountPercent, setDiscountPercent] = useState(0);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [country, setCountry] = useState("");
  const [address, setAddress] = useState("");
  const [postcode, setPostCode] = useState("");
  const [city, setCity] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [specialRequest, setSpecialRequest] = useState("");
  const [, setTotalAmount] = useState(0); // you will calculate this later
  const [villaName, setVillaName] = useState("");
  const [price, setPrice] = useState(0);
  // COUPON STATE
  const [couponCode, setCouponCode] = useState("");
  const [isCouponApplied, setIsCouponApplied] = useState(false);

  // APPLY COUPON
  // const handleApplyCoupon = () => {
  //   if (!couponCode.trim()) {
  //     alert("Please enter a coupon code.");
  //     return;
  //   }

  //   // You can modify this logic as per your coupon rules
  //   if (couponCode === "SOHAM10") {
  //     alert("Coupon applied successfully!");
  //     setIsCouponApplied(true);
  //   } else {
  //     alert("Invalid coupon code.");
  //   }
  // };
  const handleApplyCoupon = async () => {
    if (!couponCode.trim()) {
      alert("Enter a coupon code");
      return;
    }

    try {
      const res = await fetch(
        `https://sohamvillas.com/web-backend/getCouponForTao?code=${couponCode}`,
      );
      const data = await res.json();

      if (data.error) {
        alert(data.error);
        return;
      }

      setDiscountPercent(data.discount_percentage);
      setIsCouponApplied(true);

      // calculate discount on total
      const discountValue = (totalWithGst * data.discount_percentage) / 100;
      // setDiscountAmount(discountValue);
    } catch (err) {
      console.error("Coupon error:", err);
    }
  };

  // REMOVE COUPON
  // const handleRemoveCoupon = () => {
  //   setCouponCode("");
  //   setIsCouponApplied(false);
  //   alert("Coupon removed.");
  // };
  const handleRemoveCoupon = () => {
    setDiscountPercent(0);
    setIsCouponApplied(false);
    setCouponCode("");
  };
  const formatDate = (date) => {
    if (!date) return "";
    return date.toLocaleDateString("en-GB"); // dd/mm/yyyy
  };

  useEffect(() => {
    const fetchVillaDetails = async () => {
      try {
        const res = await fetch(`${API_URL}/villa-details`);
        const data = await res.json();

        setVillaName(data.villaName);
        setPrice(data.price);
        setTotalAmount(data.price); // OPTIONAL: if initial total = price
      } catch (err) {
        console.error("Error fetching villa details:", err);
      }
    };

    fetchVillaDetails();
  }, []);
  useEffect(() => {
    const fetchBlockedDates = async () => {
      try {
        const response = await fetch(
          `${API_URL}/villa-blocked-dates?villaId=18`,
        );
        const data = await response.json();

        // Directly use `blockedDates` from response
        const formattedDates = data.blockedDates.map((date) =>
          new Date(date).toDateString(),
        );

        setBlockedDates(formattedDates);
      } catch (err) {
        console.error("Error fetching blocked dates:", err);
      }
    };

    fetchBlockedDates();
  }, []);

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const daysShort = ["S", "M", "T", "W", "T", "F", "S"];

  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();
  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const prevMonth = () => setCurrentDate(new Date(year, month - 1, 1));
  const nextMonth = () => setCurrentDate(new Date(year, month + 1, 1));

  // const toggleDate = (date) => {
  //   if (selectedDates.length === 0 || selectedDates.length === 1) {
  //     if (selectedDates.length === 0) {
  //       setSelectedDates([date]);
  //       return;
  //     }

  //     const startDate = selectedDates[0];
  //     const newMin = date < startDate ? date : startDate;
  //     const newMax = date > startDate ? date : startDate;

  //     const newRange = [];

  //     for (let d = new Date(newMin); d <= newMax; d.setDate(d.getDate() + 1)) {
  //       newRange.push(new Date(d));
  //     }
  //     setSelectedDates(newRange);
  //     return;
  //   }

  //   if (selectedDates.length > 1) {
  //     setSelectedDates([date]);
  //     return;
  //   }
  // };
  // const toggleDate = (date) => {
  //   const formatted = date.toDateString();

  //   if (blockedDates.includes(formatted)) {
  //     alert("This date is unavailable.");
  //     return;
  //   }

  //   if (selectedDates.length === 0) {
  //     setSelectedDates([date]);
  //     return;
  //   }

  //   if (selectedDates.length === 1) {
  //     const startDate = selectedDates[0];
  //     const start = startDate < date ? startDate : date;
  //     const end = startDate > date ? startDate : date;

  //     const tempRange = [];

  //     for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
  //       if (blockedDates.includes(new Date(d).toDateString())) {
  //         alert(
  //           "Your selected range includes blocked dates. Please choose another range."
  //         );
  //         return;
  //       }
  //       tempRange.push(new Date(d));
  //     }

  //     setSelectedDates(tempRange);
  //     return;
  //   }

  //   setSelectedDates([date]);
  // };
  const toggleDate = (date) => {
    const formatted = date.toDateString();

    if (blockedDates.includes(formatted)) {
      alert("This date is unavailable, plase select another range.");
      return;
    }

    // Helper: create min 2-night block
    const makeTwoNightBlock = (start) => {
      const next = new Date(start);
      next.setDate(next.getDate() + 1);

      if (blockedDates.includes(next.toDateString())) {
        alert(
          "Minimum 2 nights required, but next day is blocked, please select another dates.",
        );
        return null;
      }

      return [start, next];
    };

    // ---- CASE 1: NO DATES YET ----
    if (selectedDates.length === 0) {
      const block = makeTwoNightBlock(date);
      if (block) setSelectedDates(block);
      return;
    }

    const startDate = selectedDates[0];
    const endDate = selectedDates[selectedDates.length - 1];

    // ---- CASE 2: CLICKED INSIDE RANGE -> reset to new 2-night block ----
    if (date >= startDate && date <= endDate) {
      const block = makeTwoNightBlock(date);
      if (block) setSelectedDates(block);
      return;
    }

    // ---- CASE 3: CLICK AFTER START -> EXPAND RANGE ----
    if (date > startDate) {
      const tempRange = [];
      for (let d = new Date(startDate); d <= date; d.setDate(d.getDate() + 1)) {
        if (blockedDates.includes(d.toDateString())) {
          alert(
            "Selected range includes blocked dates, please select another dates.",
          );
          return;
        }
        tempRange.push(new Date(d));
      }

      // Must be minimum 2 nights
      if (tempRange.length < 2) {
        const block = makeTwoNightBlock(startDate);
        if (block) setSelectedDates(block);
        return;
      }

      setSelectedDates(tempRange);
      return;
    }

    // ---- CASE 4: CLICK BEFORE START -> EXPAND BACKWARDS ----
    if (date < startDate) {
      const tempRange = [];
      for (let d = new Date(date); d <= endDate; d.setDate(d.getDate() + 1)) {
        if (blockedDates.includes(d.toDateString())) {
          alert("Selected range includes blocked dates.");
          return;
        }
        tempRange.push(new Date(d));
      }

      // Must be minimum 2 nights
      if (tempRange.length < 2) {
        const block = makeTwoNightBlock(date);
        if (block) setSelectedDates(block);
        return;
      }

      setSelectedDates(tempRange);
      return;
    }
  };

  const minDate =
    selectedDates.length > 0
      ? new Date(Math.min(...selectedDates.map((d) => d.getTime())))
      : null;

  const maxDate =
    selectedDates.length > 0
      ? new Date(Math.max(...selectedDates.map((d) => d.getTime())))
      : null;
  const minTime = minDate?.getTime();
  const maxTime = maxDate?.getTime();

  useEffect(() => {
    if (!minTime || !maxTime || maxTime <= minTime) {
      setNightlyPrices([]);
      return;
    }

    let cancelled = false;
    const checkin = toYMD(new Date(minTime));
    const checkout = toYMD(new Date(maxTime));

    fetch(
      `${API_URL}/villa-price-range?checkin=${checkin}&checkout=${checkout}`,
    )
      .then((r) => r.json())
      .then((data) => {
        if (!cancelled) setNightlyPrices(data.nightly || []);
      })
      .catch((err) => {
        console.error("Error fetching nightly prices:", err);
        if (!cancelled) setNightlyPrices([]); // falls back to room price below
      });

    return () => {
      cancelled = true;
    };
  }, [minTime, maxTime]);

  // GUESTS LOGIC
  const [adults, setAdults] = useState(2);
  const [children, setChildren] = useState(0);

  const totalGuests = adults + children;

  const incrementAdults = () =>
    setAdults((prev) => (prev < 12 ? prev + 1 : 12));
  const decrementAdults = () => setAdults((prev) => (prev > 1 ? prev - 1 : 1));
  const incrementChildren = () => setChildren((prev) => prev + 1);
  const decrementChildren = () =>
    setChildren((prev) => (prev > 0 ? prev - 1 : 0));

  // GSAP SCROLL ANIMATION
  const sectionsRef = useRef([]);

  const addToRefs = (el) => {
    if (el && !sectionsRef.current.includes(el)) {
      sectionsRef.current.push(el);
    }
  };

  useEffect(() => {
    sectionsRef.current.forEach((section) => {
      const texts = section.querySelectorAll("p, h2");
      gsap.fromTo(
        texts,
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          stagger: 0.1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: section,
            start: "top 80%",
            toggleActions: "play none none none",
          },
        },
      );
    });
  }, []);
  // CALCULATE NIGHTS
  const nights =
    minDate && maxDate
      ? Math.round(
          (maxDate.getTime() - minDate.getTime()) / (1000 * 60 * 60 * 24),
        )
      : 0;

  // FORMAT DATES
  const formattedCheckIn = formatDate(minDate);
  const formattedCheckOut = formatDate(maxDate);

  // PRICE CALCULATIONS

  const nightsCount = nights === 0 ? 1 : nights;

  const hasNightly = nights > 0 && nightlyPrices.length === nights;
  const basePrice = hasNightly
    ? nightlyPrices.reduce((s, n) => s + n.price, 0)
    : price * nightsCount; // fallback: rooms table price
  const fmtShort = (ymd) =>
    new Date(ymd + "T00:00:00").toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
    });

  const addOneDay = (ymd) => {
    const d = new Date(ymd + "T00:00:00");
    d.setDate(d.getDate() + 1);
    return toYMD(d);
  };

  // group consecutive nights with the same price
  const priceSummary = [];
  if (hasNightly) {
    nightlyPrices.forEach((n) => {
      const last = priceSummary[priceSummary.length - 1];
      if (last && last.price === n.price) {
        last.nights += 1;
        last.lastNight = n.date;
      } else {
        priceSummary.push({
          price: n.price,
          nights: 1,
          startDate: n.date,
          lastNight: n.date,
        });
      }
    });
    // the range ends on the morning after the last night (check-out style)
    priceSummary.forEach((g) => {
      g.endDate = addOneDay(g.lastNight);
    });
  }
  const stayLabel =
    minDate && maxDate
      ? `Check-in ${fmtShort(toYMD(minDate))} → Check-out ${fmtShort(toYMD(maxDate))}`
      : "";
  // const stayLabel =
  //   minDate && maxDate
  //     ? `Check-in ${fmtShort(toYMD(minDate))} → Check-out ${fmtShort(toYMD(maxDate))} · ${nights} night${nights > 1 ? "s" : ""}`
  //     : "";
  const uniform =
    hasNightly &&
    nightlyPrices.every((n) => n.price === nightlyPrices[0].price);
  const perNightLabel = hasNightly
    ? uniform
      ? nightlyPrices[0].price
      : Math.round(basePrice / nights) // average when rates differ
    : price;

  const gst = +(basePrice * 0.18).toFixed(2);
  const totalWithGst = basePrice + gst;
  const discountAmount = +((totalWithGst * discountPercent) / 100).toFixed(2);

  const goToSohamCheckout = () => {
    // List of required fields
    const requiredFields = [
      formattedCheckIn,
      formattedCheckOut,
      firstName,
      lastName,
      country,
      address,
      postcode,
      city,
      email,
      phone,
    ];

    // Check if any field is null, undefined, or empty
    const hasEmptyField = requiredFields.some(
      (field) => field === null || field === undefined || field === "",
    );

    if (hasEmptyField) {
      alert("Please fill all required fields before proceeding to checkout.");
      return; // Stop function execution
    }
    // SEND DATA TO BACKEND FOR EMAIL
    fetch("https://sohamvillas.com/web-backend/sendBookingEmailForTao", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        checkin: formattedCheckIn,
        checkout: formattedCheckOut,
        duration: nights,
        nights,
        villaName,
        adults,
        children,
        totalGuests: adults + children,
        firstname: firstName,
        lastname: lastName,
        country,
        address,
        postcode,
        city,
        email,
        phone,
        specialRequest,
      }),
    }).catch((err) => console.error("Email API Error:", err));

    const query = new URLSearchParams({
      checkin: formattedCheckIn,
      checkout: formattedCheckOut,
      duration: nights,
      nights,
      villaName,
      price: basePrice,
      gst,
      totalAmount: (totalWithGst - discountAmount).toFixed(2),
      discountApplied: isCouponApplied ? couponCode : "",
      discountValue: discountAmount.toFixed(2),
      adults,
      children,
      totalGuests: adults + children,
      firstname: firstName,
      lastname: lastName,
      country,
      address,
      postcode,
      city,
      email,
      phone,
      specialRequest,
    }).toString();

    // window.location.href = `https://sohamvillas.com/Checkout?${query}`;
    window.location.href = `https://sohamvillas.com/Checkout?source=tao&${query}`;
  };

  return (
    <div className="relative w-full min-h-screen bg-[#f5f2f0] flex items-center justify-center">
      <div className="overflow-y-auto overflow-x-hidden w-full">
        <div
          className="hidden lg:block fixed top-0 left-0 w-screen h-screen bg-cover bg-center z-0"
          style={{
            backgroundImage: `url('https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/60fbafe1-a470-41d4-e20d-2a333e043100/public')`,
          }}
        >
          <div className="absolute inset-0 bg-black/50"></div>

          <div className="absolute inset-0 flex items-end justify-center pb-12">
            <p
              className="text-[13px] tracking-[0.25em] uppercase text-center text-white whitespace-nowrap overflow-hidden border-r-2 border-[#948A78]"
              style={{
                width: "0ch",
                animation:
                  "typing2 2.5s steps(30) forwards, hideCursor 0.1s forwards 2.5s",
              }}
            >
              in silence, everything speaks
            </p>
          </div>

          <style jsx>{`
            @keyframes typing2 {
              from {
                width: 0;
              }
              to {
                width: 48ch;
              }
            }

            /* Remove cursor AFTER typing finishes */
            @keyframes hideCursor {
              to {
                border-color: transparent;
              }
            }
          `}</style>
        </div>

        <div
          className="lg:hidden fixed top-0 left-0 w-screen h-screen bg-cover bg-center z-0"
          style={{
            backgroundImage: `url('https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/c2e7d094-221a-4d77-c18e-58e06de6db00/public')`,
          }}
        >
          <div className="absolute inset-0 bg-black/40"></div>
          <div className="absolute inset-0 flex flex-col text-center items-center justify-center text-[14px] tracking-[0.25em] uppercase text-[#F5F2F0] leading-relaxed">
            <Typewriter
              options={{
                delay: 60,
                deleteSpeed: 30,
              }}
              onInit={(typewriter) => {
                typewriter
                  .typeString("in silence,")
                  .pauseFor(800)
                  .typeString("<br/>everything speaks")
                  .callFunction(() => {
                    const cursor = document.querySelector(
                      ".Typewriter__cursor",
                    );
                    if (cursor) cursor.style.display = "none";
                  })
                  .start();
              }}
            />
          </div>
        </div>

        <div className="relative z-10 pt-[100vh]">
          <NewHeader />

          <div className="w-screen min-h-screen bg-[#f5f2f0] flex flex-col px-6 lg:px-20 py-20 -mt-1">
            <div className="flex flex-col lg:grid lg:grid-cols-2 lg:gap-10 mb-10">
              <div ref={addToRefs} className="w-full mb-20 4k:ml-28 xl:ml-20">
                {/* HEADER */}
                <div className="relative w-full mb-10">
                  {/* MOBILE */}
                  <p className="lg:hidden text-[#948A78] text-[20px] mb-4 text-left pl-5 sm:pl-44">
                    Dates
                  </p>

                  {/* DESKTOP*/}
                  <p className="hidden lg:block text-[#948A78] text-[20px] absolute 4k:left-80 xl:left-36 lg:left-10 xl:top-1 4k:top-1 lg:-top-2 -translate-y-1/2 -ml-20">
                    Dates
                  </p>

                  {/* Arrows */}
                  <div className="flex items-center justify-center gap-4 w-full">
                    {/* PREV BUTTON */}
                    <button
                      onClick={prevMonth}
                      className="hover:opacity-60 transition"
                    >
                      <div className="flex items-center rotate-180">
                        <div className="h-[1px] w-6 lg:w-[5vw] 2xl:w-28 bg-[#948A78]"></div>
                        <div className="relative w-3 h-3 -ml-1">
                          <div className="absolute w-2 h-[1px] bg-[#948A78] transform rotate-45 origin-left top-0 left-0"></div>
                          <div className="absolute w-2 h-[1px] bg-[#948A78] transform -rotate-45 origin-left bottom-0 left-0"></div>
                        </div>
                      </div>
                    </button>

                    {/* MONTH TEXT */}
                    <p className="tracking-[0.20em] uppercase text-[13px] font-bold px-4 text-[#948A78]">
                      {monthNames[month]} {year}
                    </p>

                    {/* NEXT BUTTON */}
                    <button
                      onClick={nextMonth}
                      className="hover:opacity-60 transition"
                    >
                      <div className="flex items-center">
                        <div className="h-[1px] w-6 lg:w-[5vw] 2xl:w-28 bg-[#948A78]"></div>
                        <div className="relative w-3 h-3 -ml-1">
                          <div className="absolute w-2 h-[1px] bg-[#948A78] transform rotate-45 origin-left top-0 left-0"></div>
                          <div className="absolute w-2 h-[1px] bg-[#948A78] transform -rotate-45 origin-left bottom-0 left-0"></div>
                        </div>
                      </div>
                    </button>
                  </div>
                </div>

                {/* CALENDAR GRID */}
                <div className="grid grid-cols-7 text-center text-[13px] gap-y-5 sm:px-40 lg:px-8 xl:px-36 4k:px-44">
                  {daysShort.map((d, i) => (
                    <p
                      key={`${d}-${i}`}
                      className="opacity-60 text-[#948A78] font-bold"
                    >
                      {d}
                    </p>
                  ))}

                  {Array.from({ length: firstDay }).map((_, i) => (
                    <p key={`empty-${i}`}></p>
                  ))}

                  {Array.from({ length: daysInMonth }).map((_, day) => {
                    const currentDay = new Date(year, month, day + 1);
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);

                    const formatted = currentDay.toDateString();

                    const isPast = currentDay < today;
                    const isBlocked = blockedDates.includes(formatted);
                    const isDisabled = isPast || isBlocked;

                    const isInRange =
                      minDate &&
                      maxDate &&
                      currentDay.getTime() >= minDate.getTime() &&
                      currentDay.getTime() <= maxDate.getTime();

                    const isFirst =
                      minDate && currentDay.getTime() === minDate.getTime();
                    const isLast =
                      maxDate && currentDay.getTime() === maxDate.getTime();

                    return (
                      <div
                        key={day}
                        className="relative w-full flex flex-col items-center"
                      >
                        {/* <p
                          onClick={() => toggleDate(currentDay)}
                          className={`py-2 cursor-pointer transition text-[#948A78]`}
                        >
                          {day + 1}
                        </p> */}
                        <p
                          onClick={() => !isDisabled && toggleDate(currentDay)}
                          className={`py-2 cursor-pointer transition text-[#948A78] 
    ${isDisabled ? "opacity-30 cursor-not-allowed line-through" : ""}
    ${isInRange ? "font-semibold" : ""}
  `}
                        >
                          {day + 1}
                        </p>

                        {isInRange && (
                          <span
                            className={`block h-[1px] w-full bg-[#877D6F]
                                ${isFirst ? "rounded-l-full" : ""}
                                ${isLast ? "rounded-r-full" : ""}`}
                          ></span>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* 2. GUESTS SECTION (Right) */}
              <div
                ref={addToRefs}
                className="w-full bg-[#f5f2f0] p-5 text-[#948A78]"
              >
                <div className="lg:w-full bg-[#f5f2f0] p-6 text-[#948A78] rounded-lg mt-10 sm:ml-20 ml-1">
                  <p className="text-[20px] 2xl:ml-28 xl:-ml-3 lg:-ml-20 sm:ml-12 -ml-14">
                    Guests
                  </p>

                  <div className="flex items-center justify-between mb-6 2xl:px-60 xl:px-20 lg:px-0 sm:px-36 px-1">
                    <p className="text-[14px] uppercase tracking-[0.25em]">
                      {totalGuests}&nbsp;Guests
                    </p>
                  </div>

                  <div className="flex items-center justify-between mb-5 2xl:px-60 xl:px-20 lg:px-0 sm:px-36 px-1">
                    <p className="text-[13px] font-semibold uppercase tracking-[0.25em]">
                      Adults
                    </p>

                    <div className="flex items-center justify-center gap-2 sm:ml-0 xl:mr-20">
                      <button
                        onClick={decrementAdults}
                        className="text-xl w-8 h-8 flex items-center justify-center"
                      >
                        −
                      </button>

                      <p>{adults}</p>

                      <button
                        onClick={incrementAdults}
                        className="text-xl w-8 h-8 flex items-center justify-center"
                      >
                        +
                      </button>
                    </div>
                  </div>

                  <div className="flex items-center justify-between mb-6 2xl:px-60 xl:px-20 lg:px-0 sm:px-36 px-1">
                    <p className="text-[13px] font-semibold uppercase tracking-[0.25em]">
                      Children
                      <br />
                      <span className="font-normal">(1-12&nbsp;years)</span>
                    </p>

                    <div className="flex items-center justify-center gap-2 sm:ml-0 xl:mr-20">
                      <button
                        onClick={decrementChildren}
                        className="text-xl w-8 h-8 flex items-center justify-center"
                      >
                        −
                      </button>

                      <p>{children}</p>

                      <button
                        onClick={incrementChildren}
                        className="text-xl w-8 h-8 flex items-center justify-center"
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 3. PRICING DETAILS SECTION (Bottom) */}
            <div className="flex flex-col lg:flex-row justify-between gap-10">
              <div className="lg:w-1/2">
                <div className="mb-2 text-right ">
                  <p className="text-[#948A78] text-[20px] 4k:mr-[28vw] xl:mr-[30vw] lg:mr-[39vw] sm:mr-[70vw] mr-[50vh]">
                    Guest
                    <br />
                    Details
                  </p>
                </div>

                <div className="space-y-8 w-[90%] max-w-[360px]  sm:ml-[27vw] xl:ml-[15vw] 4k:ml-[20vw] ml-10 lg:ml-[5vw]">
                  <div>
                    <input
                      type="text"
                      placeholder="First Name *"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                    />
                    <div className="border-b border-[#877D6F]"></div>
                  </div>

                  <div>
                    <input
                      type="text"
                      placeholder="Last Name *"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                      className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                    />
                    <div className="border-b border-[#877D6F]"></div>
                  </div>
                  {/* 
                  <div>
                    <input
                      type="text"
                      placeholder="Country *"
                      value={country}
                      onChange={(e) => setCountry(e.target.value)}
                      className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                    />
                    <div className="border-b border-[#877D6F]"></div>
                  </div> */}
                  <div>
                    <select
                      value={country}
                      onChange={(e) => setCountry(e.target.value)}
                      className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                      style={{ appearance: "none" }}
                    >
                      <option value="" disabled>
                        COUNTRY *
                      </option>

                      {[
                        "Afghanistan",
                        "Albania",
                        "Algeria",
                        "Andorra",
                        "Angola",
                        "Antigua and Barbuda",
                        "Argentina",
                        "Armenia",
                        "Australia",
                        "Austria",
                        "Azerbaijan",
                        "Bahamas",
                        "Bahrain",
                        "Bangladesh",
                        "Barbados",
                        "Belarus",
                        "Belgium",
                        "Belize",
                        "Benin",
                        "Bhutan",
                        "Bolivia",
                        "Bosnia and Herzegovina",
                        "Botswana",
                        "Brazil",
                        "Brunei",
                        "Bulgaria",
                        "Burkina Faso",
                        "Burundi",
                        "Cabo Verde",
                        "Cambodia",
                        "Cameroon",
                        "Canada",
                        "Central African Republic",
                        "Chad",
                        "Chile",
                        "China",
                        "Colombia",
                        "Comoros",
                        "Congo (Congo-Brazzaville)",
                        "Costa Rica",
                        "Croatia",
                        "Cuba",
                        "Cyprus",
                        "Czechia (Czech Republic)",
                        "Denmark",
                        "Djibouti",
                        "Dominica",
                        "Dominican Republic",
                        "Ecuador",
                        "Egypt",
                        "El Salvador",
                        "Equatorial Guinea",
                        "Eritrea",
                        "Estonia",
                        "Eswatini (fmr. 'Swaziland')",
                        "Ethiopia",
                        "Fiji",
                        "Finland",
                        "France",
                        "Gabon",
                        "Gambia",
                        "Georgia",
                        "Germany",
                        "Ghana",
                        "Greece",
                        "Grenada",
                        "Guatemala",
                        "Guinea",
                        "Guinea-Bissau",
                        "Guyana",
                        "Haiti",
                        "Holy See",
                        "Honduras",
                        "Hungary",
                        "Iceland",
                        "India",
                        "Indonesia",
                        "Iran",
                        "Iraq",
                        "Ireland",
                        "Israel",
                        "Italy",
                        "Jamaica",
                        "Japan",
                        "Jordan",
                        "Kazakhstan",
                        "Kenya",
                        "Kiribati",
                        "Korea (North)",
                        "Korea (South)",
                        "Kosovo",
                        "Kuwait",
                        "Kyrgyzstan",
                        "Laos",
                        "Latvia",
                        "Lebanon",
                        "Lesotho",
                        "Liberia",
                        "Libya",
                        "Liechtenstein",
                        "Lithuania",
                        "Luxembourg",
                        "Madagascar",
                        "Malawi",
                        "Malaysia",
                        "Maldives",
                        "Mali",
                        "Malta",
                        "Marshall Islands",
                        "Mauritania",
                        "Mauritius",
                        "Mexico",
                        "Micronesia",
                        "Moldova",
                        "Monaco",
                        "Mongolia",
                        "Montenegro",
                        "Morocco",
                        "Mozambique",
                        "Myanmar (formerly Burma)",
                        "Namibia",
                        "Nauru",
                        "Nepal",
                        "Netherlands",
                        "New Zealand",
                        "Nicaragua",
                        "Niger",
                        "Nigeria",
                        "North Macedonia (formerly Macedonia)",
                        "Norway",
                        "Oman",
                        "Pakistan",
                        "Palau",
                        "Palestine State",
                        "Panama",
                        "Papua New Guinea",
                        "Paraguay",
                        "Peru",
                        "Philippines",
                        "Poland",
                        "Portugal",
                        "Qatar",
                        "Romania",
                        "Russia",
                        "Rwanda",
                        "Saint Kitts and Nevis",
                        "Saint Lucia",
                        "Saint Vincent and the Grenadines",
                        "Samoa",
                        "San Marino",
                        "Sao Tome and Principe",
                        "Saudi Arabia",
                        "Senegal",
                        "Serbia",
                        "Seychelles",
                        "Sierra Leone",
                        "Singapore",
                        "Slovakia",
                        "Slovenia",
                        "Solomon Islands",
                        "Somalia",
                        "South Africa",
                        "South Sudan",
                        "Spain",
                        "Sri Lanka",
                        "Sudan",
                        "Suriname",
                        "Sweden",
                        "Switzerland",
                        "Syria",
                        "Tajikistan",
                        "Tanzania",
                        "Thailand",
                        "Timor-Leste",
                        "Togo",
                        "Tonga",
                        "Trinidad and Tobago",
                        "Tunisia",
                        "Turkey",
                        "Turkmenistan",
                        "Tuvalu",
                        "Uganda",
                        "Ukraine",
                        "United Arab Emirates",
                        "United Kingdom",
                        "United States",
                        "Uruguay",
                        "Uzbekistan",
                        "Vanuatu",
                        "Venezuela",
                        "Vietnam",
                        "Yemen",
                        "Zambia",
                        "Zimbabwe",
                      ].map((c) => (
                        <option key={c} value={c}>
                          {c.toUpperCase()}
                        </option>
                      ))}
                    </select>

                    <div className="border-b border-[#877D6F]"></div>
                  </div>

                  <div>
                    <input
                      type="text"
                      placeholder="City *"
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                      className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                    />
                    <div className="border-b border-[#877D6F]"></div>
                  </div>
                  <div>
                    <input
                      type="text"
                      placeholder="Address *"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                    />
                    <div className="border-b border-[#877D6F]"></div>
                  </div>
                  <div>
                    <input
                      type="text"
                      placeholder="Postcode/Zipcode *"
                      value={postcode}
                      onChange={(e) => setPostCode(e.target.value)}
                      className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                    />
                    <div className="border-b border-[#877D6F]"></div>
                  </div>
                  <div>
                    <input
                      type="email"
                      placeholder="Email ID *"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                    />
                    <div className="border-b border-[#877D6F]"></div>
                  </div>
                  <div>
                    <input
                      type="tel"
                      placeholder="Phone *"
                      maxLength={10}
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                    />
                    <div className="border-b border-[#877D6F]"></div>
                  </div>
                  <div>
                    <textarea
                      placeholder="Special Request"
                      value={specialRequest}
                      onChange={(e) => setSpecialRequest(e.target.value)}
                      className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
                    />
                    <div className="border-b border-[#877D6F] mt-20 mb-5"></div>
                  </div>

                  {/* <button
                                  className="tracking-[0.25em] sm:ml-44 text-[13px] uppercase text-[#948A78] w-full text-left hover:font-bold underline decoration-[#948A78] underline-offset-[12px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
                              >
                                  Submit&nbsp;&&nbsp;Continue
                              </button> */}
                </div>
              </div>

              <div ref={addToRefs} className="lg:w-1/2 bg-[#f5f2f0] p-6 ">
                <div className="hidden lg:block">
                  <p className="text-[#948A78] text-[20px] mb-6 text-right 2xl:mr-[31vw] xl:mr-[30vw] lg:mr-[50vw]">
                    Pricing <br /> Details
                  </p>

                  <div className="text-[13px] tracking-[0.2em] text-[#948A78] space-y-4 pl-48 4k:pl-[15vw] xl:pl-[12vw] lg:pl-[8vw]">
                    <CouponBox
                      couponCode={couponCode}
                      setCouponCode={setCouponCode}
                      applyCoupon={handleApplyCoupon}
                      removeCoupon={handleRemoveCoupon}
                      isCouponApplied={isCouponApplied}
                    />

                    {/* Desktop */}
                    <PriceBreakdown
                      hasNightly={hasNightly}
                      priceSummary={priceSummary}
                      fmtShort={fmtShort}
                      price={price}
                      nightsCount={nightsCount}
                      basePrice={basePrice}
                      stayLabel={stayLabel}
                      widthClass="w-[300px]"
                    />
                    <div className="grid grid-cols-2 w-[300px]">
                      <p>GST @ 18%</p>
                      <p className="text-right">Rs {gst}</p>
                    </div>
                    {/* <div className="grid grid-cols-2 w-[300px]">
                      <p>Convenience Fee @ 3.7%</p>
                      <p className="text-right">Rs {convenienceFee}</p>
                    </div> */}
                    <div className="pt-6">
                      <div className="grid grid-cols-2 w-[300px] uppercase font-bold tracking-[0.3em]">
                        <p>Total Cost</p>
                        {/* <p className="text-right">Rs {totalWithGst}</p> */}
                        <p className="text-right">
                          {" "}
                          Rs {(totalWithGst - discountAmount).toFixed(2)}
                        </p>
                      </div>
                      {/* <p className="text-[13px] tracking-[0.25em] mt-8 2xl:ml-[18vh] xl:ml-[35vh] lg:ml-60">
                        Rs&nbsp;xx
                        <br />
                        per&nbsp;person
                      </p> */}
                      <p className="text-[13px] tracking-[0.25em] mt-20 2xl:ml-[18vh] xl:ml-[35vh] lg:ml-60">
                        <button
                          onClick={goToSohamCheckout}
                          className="uppercase tracking-[0.25em] text-[12px] hover:font-bold underline decoration-[#948A78] underline-offset-[10px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
                        >
                          Book&nbsp;Now
                        </button>
                      </p>
                    </div>
                  </div>
                </div>

                <div className="block lg:hidden text-left px-8 ">
                  <p className="text-[#948A78] text-[20px] mb-6 sm:ml-[8vw] -ml-12">
                    Pricing <br /> Details
                  </p>
                  <CouponBox
                    couponCode={couponCode}
                    setCouponCode={setCouponCode}
                    applyCoupon={handleApplyCoupon}
                    removeCoupon={handleRemoveCoupon}
                    isCouponApplied={isCouponApplied}
                  />
                  {/* Mobile */}
                  <div className="text-[13px] tracking-[0.2em] text-[#948A78] space-y-4 ">
                    <PriceBreakdown
                      hasNightly={hasNightly}
                      priceSummary={priceSummary}
                      fmtShort={fmtShort}
                      price={price}
                      nightsCount={nightsCount}
                      basePrice={basePrice}
                      stayLabel={stayLabel}
                      widthClass="w-full max-w-xs mx-auto"
                    />
                    <div className="grid grid-cols-2 w-full max-w-xs mx-auto">
                      <p>GST @ 18%</p>
                      <p className="text-right">Rs {gst}</p>
                    </div>
                    {/* <div className="grid grid-cols-2 w-full max-w-xs mx-auto">
                      <p>Convenience Fee</p>
                      <p className="text-right">Rs xx</p>
                    </div> */}
                    <div className="pt-6">
                      <div className="grid grid-cols-2 w-full max-w-xs mx-auto uppercase font-bold tracking-[0.3em]">
                        <p>Total Cost</p>
                        <p className="text-right">
                          {" "}
                          Rs {(totalWithGst - discountAmount).toFixed(2)}
                        </p>
                      </div>
                      <div className="grid grid-cols-2 w-full max-w-xs ml-auto mt-8 sm:ml-48">
                        {/* <p className="justify-self-end text-[13px] tracking-[0.25em] text-[#948A78]">
                          Rs&nbsp;xx
                          <br />
                          per&nbsp;person
                        </p> */}
                        <div />
                        <p className="justify-self-end text-[13px] tracking-[0.25em] text-[#948A78] mt-20">
                          <button
                            onClick={goToSohamCheckout}
                            className="uppercase tracking-[0.25em] text-[12px] hover:font-bold underline decoration-[#948A78] underline-offset-[10px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
                          >
                            Book&nbsp;Now
                          </button>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <NewFooter />
        </div>
      </div>
    </div>
  );
};

export default BookNow;

const CouponBox = ({
  couponCode,
  setCouponCode,
  applyCoupon,
  removeCoupon,
  isCouponApplied,
}) => {
  return (
    <div className="pt-2 pb-8 rounded-md mx-auto xl:mx-0 max-w-[330px]">
      <p className="text-[#948A78] mb-2 text-[13px] tracking-[0.1em] ">
        Apply Coupon
      </p>

      <div className="flex gap-2 border border-[#948A78]/30 px-3 py-5">
        <input
          type="text"
          value={couponCode}
          onChange={(e) => setCouponCode(e.target.value)}
          className="w-full bg-transparent outline-none text-[#948A78] text-[13px] tracking-[0.3em] placeholder-[#B5AC9E]"
          placeholder="Coupon Code"
        />

        <button
          onClick={applyCoupon}
          className="uppercase tracking-[0.25em] text-[12px] hover:font-bold underline decoration-[#948A78] underline-offset-[10px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
        >
          APPLY
        </button>
      </div>

      {isCouponApplied && (
        <button
          onClick={removeCoupon}
          className="text-red-300 text-[12px]  mt-2"
        >
          Remove applied coupon
        </button>
      )}
    </div>
  );
};
const PriceBreakdown = ({
  hasNightly,
  priceSummary,
  fmtShort,
  price,
  nightsCount,
  basePrice,
  stayLabel,
  widthClass,
}) => {
  if (!hasNightly) {
    // fallback: rooms table price
    return (
      <div className={`grid grid-cols-2 ${widthClass}`}>
        <p>
          Rs {price}
          <br /> X {nightsCount} night{nightsCount > 1 ? "s" : ""}
        </p>
        <p className="text-right">Rs {basePrice}</p>
      </div>
    );
  }

  return (
    <div className={`space-y-3 ${widthClass}`}>
      {stayLabel && <p className="pb-2 normal-case">{stayLabel}</p>}

      {priceSummary.map((g) => (
        <div key={g.startDate} className="grid grid-cols-[1fr_auto] gap-4">
          <div>
            <p>
              {fmtShort(g.startDate)} – {fmtShort(g.endDate)}
            </p>
            <p className="opacity-70 text-[11px]">
              {g.nights} night{g.nights > 1 ? "s" : ""} × Rs {g.price}
            </p>
          </div>
          <p className="text-right whitespace-nowrap">
            Rs {g.price * g.nights}
          </p>
        </div>
      ))}

      <div className="grid grid-cols-[1fr_auto] gap-4 pt-2">
        <p>Subtotal</p>
        <p className="text-right whitespace-nowrap">Rs {basePrice}</p>
      </div>
    </div>
  );
};

// import React, { useState, useRef, useEffect } from "react";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import NewHeader from "../Header/NewHeader";
// import NewFooter from "../Footer/NewFooter";
// import Typewriter from "typewriter-effect";
// import { API_URL } from "../../Config";
// gsap.registerPlugin(ScrollTrigger);

// const BookNow = () => {
//   // CALENDAR STATE
//   const [currentDate, setCurrentDate] = useState(new Date());
//   const [selectedDates, setSelectedDates] = useState([]);
//   const [unavailableDates, setUnavailableDates] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const monthNames = [
//     "January",
//     "February",
//     "March",
//     "April",
//     "May",
//     "June",
//     "July",
//     "August",
//     "September",
//     "October",
//     "November",
//     "December",
//   ];
//   const daysShort = ["S", "M", "T", "W", "T", "F", "S"];

//   const year = currentDate.getFullYear();
//   const month = currentDate.getMonth();
//   const firstDay = new Date(year, month, 1).getDay();
//   const daysInMonth = new Date(year, month + 1, 0).getDate();

//   const prevMonth = () => setCurrentDate(new Date(year, month - 1, 1));
//   const nextMonth = () => setCurrentDate(new Date(year, month + 1, 1));

//   // DATE RANGE LOGIC
//   const toggleDate = (date) => {
//     if (selectedDates.length === 0) {
//       setSelectedDates([date]);
//       return;
//     }

//     const min = new Date(Math.min(...selectedDates.map((d) => d.getTime())));
//     const max = new Date(Math.max(...selectedDates.map((d) => d.getTime())));

//     if (date < min) {
//       const newRange = [];
//       for (let d = new Date(date); d <= max; d.setDate(d.getDate() + 1)) {
//         newRange.push(new Date(d));
//       }
//       setSelectedDates(newRange);
//     } else if (date > max) {
//       const newRange = [];
//       for (let d = new Date(min); d <= date; d.setDate(d.getDate() + 1)) {
//         newRange.push(new Date(d));
//       }
//       setSelectedDates(newRange);
//     } else {
//       const diffToStart = date.getTime() - min.getTime();
//       const diffToEnd = max.getTime() - date.getTime();
//       const newRange = [];

//       if (diffToStart <= diffToEnd) {
//         for (let d = new Date(date); d <= max; d.setDate(d.getDate() + 1)) {
//           newRange.push(new Date(d));
//         }
//       } else {
//         for (let d = new Date(min); d <= date; d.setDate(d.getDate() + 1)) {
//           newRange.push(new Date(d));
//         }
//       }
//       setSelectedDates(newRange);
//     }
//   };

//   const minDate =
//     selectedDates.length > 0
//       ? new Date(Math.min(...selectedDates.map((d) => d.getTime())))
//       : null;

//   const maxDate =
//     selectedDates.length > 0
//       ? new Date(Math.max(...selectedDates.map((d) => d.getTime())))
//       : null;

//   // GUESTS LOGIC
//   const [adults, setAdults] = useState(2);
//   const [children, setChildren] = useState(0);

//   const totalGuests = adults + children;

//   const incrementAdults = () =>
//     setAdults((prev) => (prev < 12 ? prev + 1 : 12));

//   const decrementAdults = () => setAdults((prev) => (prev > 1 ? prev - 1 : 1));

//   const incrementChildren = () => setChildren((prev) => prev + 1);

//   const decrementChildren = () =>
//     setChildren((prev) => (prev > 0 ? prev - 0 : 0));

//   // GSAP SCROLL ANIMATION
//   const sectionsRef = useRef([]);

//   const addToRefs = (el) => {
//     if (el && !sectionsRef.current.includes(el)) {
//       sectionsRef.current.push(el);
//     }
//   };

//   useEffect(() => {
//     sectionsRef.current.forEach((section) => {
//       const texts = section.querySelectorAll("p, h2");
//       gsap.fromTo(
//         texts,
//         { opacity: 0, y: 50 },
//         {
//           opacity: 1,
//           y: 0,
//           duration: 1,
//           stagger: 0.1,
//           ease: "power2.out",
//           scrollTrigger: {
//             trigger: section,
//             start: "top 80%",
//             toggleActions: "play none none none",
//           },
//         }
//       );
//     });
//   }, []);
//   useEffect(() => {
//     const fetchAvailability = async () => {
//       setLoading(true);

//       // build first and last date of displayed month
//       const startDate = new Date(year, month, 1).toISOString().split("T")[0];
//       const endDate = new Date(year, month + 1, 0).toISOString().split("T")[0];

//       try {
//         const response = await fetch(
//           `${API_URL}/bookingAvailabilityController?startDate=${startDate}&endDate=${endDate}`
//         );
//         const data = await response.json();

//         // Filter only villas with no availability
//         const fullyBooked = data.availability.filter((v) => v.available === 0);

//         // Convert to a list of dates (per day)
//         const bookedDays = fullyBooked.flatMap((villa) => {
//           const start = new Date(startDate);
//           const end = new Date(endDate);
//           const dates = [];
//           for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
//             dates.push(new Date(d));
//           }
//           return dates;
//         });

//         setUnavailableDates(bookedDays);
//       } catch (error) {
//         console.log("Error fetching availability", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAvailability();
//   }, [year, month]);

//   return (
//     <div className="relative w-full min-h-screen bg-[#f5f2f0] flex items-center justify-center">
//       <div className="overflow-y-auto overflow-x-hidden w-full">
//         <div
//           className="hidden lg:block fixed top-0 left-0 w-screen h-screen bg-cover bg-center z-0"
//           style={{
//             backgroundImage: `url('https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/60fbafe1-a470-41d4-e20d-2a333e043100/public')`,
//           }}
//         >
//           <div className="absolute inset-0 bg-black/50"></div>

//           <div className="absolute inset-0 flex items-end justify-center pb-12">
//             <p
//               className="text-[13px] tracking-[0.25em] uppercase text-center text-white whitespace-nowrap overflow-hidden border-r-2 border-[#948A78]"
//               style={{
//                 width: "0ch",
//                 animation:
//                   "typing2 2.5s steps(30) forwards, hideCursor 0.1s forwards 2.5s",
//               }}
//             >
//               in silence, everything speaks
//             </p>
//           </div>

//           <style jsx>{`
//             @keyframes typing2 {
//               from {
//                 width: 0;
//               }
//               to {
//                 width: 48ch;
//               }
//             }

//             /* Remove cursor AFTER typing finishes */
//             @keyframes hideCursor {
//               to {
//                 border-color: transparent;
//               }
//             }
//           `}</style>
//         </div>

//         <div
//           className="lg:hidden fixed top-0 left-0 w-screen h-screen bg-cover bg-center z-0"
//           style={{
//             backgroundImage: `url('https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/c2e7d094-221a-4d77-c18e-58e06de6db00/public')`,
//           }}
//         >
//           <div className="absolute inset-0 bg-black/40"></div>
//           <div className="absolute inset-0 flex flex-col text-center items-center justify-center text-[14px] tracking-[0.25em] uppercase text-[#F5F2F0] leading-relaxed">
//             <Typewriter
//               options={{
//                 delay: 60,
//                 deleteSpeed: 30,
//               }}
//               onInit={(typewriter) => {
//                 typewriter
//                   .typeString("in silence,")
//                   .pauseFor(800)
//                   .typeString("<br/>everything speaks")
//                   .callFunction(() => {
//                     const cursor = document.querySelector(
//                       ".Typewriter__cursor"
//                     );
//                     if (cursor) cursor.style.display = "none";
//                   })
//                   .start();
//               }}
//             />
//           </div>
//         </div>

//         <div className="relative z-10 pt-[100vh]">
//           <NewHeader />

//           <div className="w-screen min-h-screen bg-[#f5f2f0] flex flex-col px-6 lg:px-20 py-20 -mt-1">
//             <div className="flex flex-col lg:grid lg:grid-cols-2 lg:gap-10 mb-10">
//               <div ref={addToRefs} className="w-full mb-20 4k:ml-28 xl:ml-20">
//                 {/* HEADER */}
//                 <div className="relative w-full mb-10">
//                   {/* MOBILE + TABLET: Dates LEFT */}
//                   <p className="lg:hidden text-[#948A78] text-[20px] mb-4 text-left pl-5 sm:pl-44">
//                     Dates
//                   </p>

//                   {/* DESKTOP: Dates LEFT FIXED */}
//                   <p className="hidden lg:block text-[#948A78] text-[20px] absolute 4k:left-80 xl:left-36 lg:left-10 xl:top-1 4k:top-1 lg:-top-2 -translate-y-1/2 -ml-20">
//                     Dates
//                   </p>

//                   {/* Arrows + Month CENTERED */}
//                   <div className="flex items-center justify-center gap-4 w-full">
//                     {/* PREV BUTTON */}
//                     <button
//                       onClick={prevMonth}
//                       className="hover:opacity-60 transition"
//                     >
//                       <div className="flex items-center rotate-180">
//                         <div className="h-[1px] w-6 lg:w-[5vw] 2xl:w-28 bg-[#948A78]"></div>
//                         <div className="relative w-3 h-3 -ml-1">
//                           <div className="absolute w-2 h-[1px] bg-[#948A78] transform rotate-45 origin-left top-0 left-0"></div>
//                           <div className="absolute w-2 h-[1px] bg-[#948A78] transform -rotate-45 origin-left bottom-0 left-0"></div>
//                         </div>
//                       </div>
//                     </button>

//                     {/* MONTH TEXT */}
//                     <p className="tracking-[0.20em] uppercase text-[13px] font-bold px-4 text-[#948A78]">
//                       {monthNames[month]} {year}
//                     </p>

//                     {/* NEXT BUTTON */}
//                     <button
//                       onClick={nextMonth}
//                       className="hover:opacity-60 transition"
//                     >
//                       <div className="flex items-center">
//                         <div className="h-[1px] w-6 lg:w-[5vw] 2xl:w-28 bg-[#948A78]"></div>
//                         <div className="relative w-3 h-3 -ml-1">
//                           <div className="absolute w-2 h-[1px] bg-[#948A78] transform rotate-45 origin-left top-0 left-0"></div>
//                           <div className="absolute w-2 h-[1px] bg-[#948A78] transform -rotate-45 origin-left bottom-0 left-0"></div>
//                         </div>
//                       </div>
//                     </button>
//                   </div>
//                 </div>

//                 {/* CALENDAR GRID */}
//                 <div className="grid grid-cols-7 text-center text-[13px] gap-y-5 sm:px-40 lg:px-8 xl:px-36 4k:px-44">
//                   {daysShort.map((d) => (
//                     <p key={d} className="opacity-60 text-[#948A78] font-bold">
//                       {d}
//                     </p>
//                   ))}

//                   {Array.from({ length: firstDay }).map((_, i) => (
//                     <p key={`empty-${i}`}></p>
//                   ))}

//                   {Array.from({ length: daysInMonth }).map((_, day) => {
//                     const currentDay = new Date(year, month, day + 1);

//                     const isPast =
//                       currentDay < new Date(new Date().setHours(0, 0, 0, 0));

//                     const isUnavailable = unavailableDates.some(
//                       (d) => d.toDateString() === currentDay.toDateString()
//                     );

//                     const isInRange =
//                       minDate &&
//                       maxDate &&
//                       currentDay.getTime() >= minDate.getTime() &&
//                       currentDay.getTime() <= maxDate.getTime();

//                     const isFirst =
//                       minDate && currentDay.getTime() === minDate.getTime();
//                     const isLast =
//                       maxDate && currentDay.getTime() === maxDate.getTime();
//                     const isDisabled = isPast || isUnavailable;

//                     return (
//                       <div
//                         key={day}
//                         className="relative w-full flex flex-col items-center"
//                       >
//                         <p
//                           onClick={() => {
//                             if (!isDisabled) toggleDate(currentDay);
//                           }}
//                           className={`
//     py-2 transition text-[#948A78]

//     ${isDisabled ? "opacity-30 cursor-not-allowed" : "cursor-pointer"}
//   `}
//                         >
//                           {day + 1}
//                         </p>

//                         {isInRange && (
//                           <span
//                             className={`block h-[1px] w-full bg-[#877D6F]
//                                                 ${
//                                                   isFirst
//                                                     ? "rounded-l-full"
//                                                     : ""
//                                                 }
//                                                 ${
//                                                   isLast ? "rounded-r-full" : ""
//                                                 }`}
//                           ></span>
//                         )}
//                       </div>
//                     );
//                   })}
//                 </div>
//               </div>

//               {/* 2. GUESTS SECTION (Right) */}
//               <div
//                 ref={addToRefs}
//                 className="w-full bg-[#f5f2f0] p-5 text-[#948A78]"
//               >
//                 <div className="lg:w-full bg-[#f5f2f0] p-6 text-[#948A78] rounded-lg mt-10 sm:ml-20 ml-1">
//                   <p className="text-[20px] 2xl:ml-28 xl:-ml-3 lg:-ml-20 sm:ml-12 -ml-14">
//                     Guests
//                   </p>

//                   <div className="flex items-center justify-between mb-6 2xl:px-60 xl:px-20 lg:px-0 sm:px-36 px-1">
//                     <p className="text-[14px] uppercase tracking-[0.25em]">
//                       {totalGuests}&nbsp;Guests
//                     </p>
//                   </div>

//                   <div className="flex items-center justify-between mb-5 2xl:px-60 xl:px-20 lg:px-0 sm:px-36 px-1">
//                     <p className="text-[13px] font-semibold uppercase tracking-[0.25em]">
//                       Adults
//                     </p>

//                     <div className="flex items-center justify-center gap-2 sm:ml-0 xl:mr-20">
//                       <button
//                         onClick={decrementAdults}
//                         className="text-xl w-8 h-8 flex items-center justify-center"
//                       >
//                         −
//                       </button>

//                       <p>{adults}</p>

//                       <button
//                         onClick={incrementAdults}
//                         className="text-xl w-8 h-8 flex items-center justify-center"
//                       >
//                         +
//                       </button>
//                     </div>
//                   </div>

//                   <div className="flex items-center justify-between mb-6 2xl:px-60 xl:px-20 lg:px-0 sm:px-36 px-1">
//                     <p className="text-[13px] font-semibold uppercase tracking-[0.25em]">
//                       Children
//                       <br />
//                       <span className="font-normal">(1-12&nbsp;years)</span>
//                     </p>

//                     <div className="flex items-center justify-center gap-2 sm:ml-0 xl:mr-20">
//                       <button
//                         onClick={decrementChildren}
//                         className="text-xl w-8 h-8 flex items-center justify-center"
//                       >
//                         −
//                       </button>

//                       <p>{children}</p>

//                       <button
//                         onClick={incrementChildren}
//                         className="text-xl w-8 h-8 flex items-center justify-center"
//                       >
//                         +
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* 3. PRICING DETAILS SECTION (Bottom) */}
//             <div className="flex flex-col lg:flex-row justify-between gap-10">
//               <div className="lg:w-1/2">
//                 <div className="mb-2 text-right ">
//                   <p className="text-[#948A78] text-[20px] 4k:mr-[28vw] xl:mr-[30vw] lg:mr-[39vw] sm:mr-[70vw] mr-[50vh]">
//                     Guest
//                     <br />
//                     Details
//                   </p>
//                 </div>

//                 <div className="space-y-8 w-[90%] max-w-[360px]  sm:ml-[27vw] xl:ml-[15vw] 4k:ml-[20vw] ml-10 lg:ml-[5vw]">
//                   <div>
//                     <input
//                       type="text"
//                       placeholder="First Name"
//                       className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
//                     />
//                     <div className="border-b border-[#877D6F]"></div>
//                   </div>

//                   <div>
//                     <input
//                       type="text"
//                       placeholder="Last Name"
//                       className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
//                     />
//                     <div className="border-b border-[#877D6F]"></div>
//                   </div>

//                   <div>
//                     <input
//                       type="tel"
//                       placeholder="Mobile"
//                       className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
//                     />
//                     <div className="border-b border-[#877D6F]"></div>
//                   </div>

//                   <div>
//                     <input
//                       type="email"
//                       placeholder="Email ID"
//                       className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
//                     />
//                     <div className="border-b border-[#877D6F]"></div>
//                   </div>

//                   <div>
//                     <textarea
//                       placeholder="Special Request"
//                       className="w-full bg-transparent outline-none text-[#948A78] text-[13px] uppercase tracking-[0.3em] placeholder-[#B5AC9E]"
//                     />
//                     <div className="border-b border-[#877D6F] mt-20 mb-5"></div>
//                   </div>

//                   {/* <button
//                                   className="tracking-[0.25em] sm:ml-44 text-[13px] uppercase text-[#948A78] w-full text-left hover:font-bold underline decoration-[#948A78] underline-offset-[12px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
//                               >
//                                   Submit&nbsp;&&nbsp;Continue
//                               </button> */}
//                 </div>
//               </div>

//               <div ref={addToRefs} className="lg:w-1/2 bg-[#f5f2f0] p-6">
//                 <div className="hidden lg:block">
//                   <p className="text-[#948A78] text-[20px] mb-6 text-right 2xl:mr-[31vw] xl:mr-[30vw] lg:mr-[50vw]">
//                     Pricing <br /> Details
//                   </p>

//                   <div className="text-[13px] tracking-[0.2em] text-[#948A78] space-y-4 pl-48 4k:pl-[15vw] xl:pl-[12vw] lg:pl-[8vw]">
//                     <div className="grid grid-cols-2 w-[300px]">
//                       <p>Rs xx X 1 night</p>
//                       <p className="text-right">Rs xx</p>
//                     </div>
//                     <div className="grid grid-cols-2 w-[300px]">
//                       <p>GST @ 12%</p>
//                       <p className="text-right">Rs xx</p>
//                     </div>
//                     <div className="grid grid-cols-2 w-[300px]">
//                       <p>Convenience Fee</p>
//                       <p className="text-right">Rs xx</p>
//                     </div>
//                     <div className="pt-6">
//                       <div className="grid grid-cols-2 w-[300px] uppercase font-bold tracking-[0.3em]">
//                         <p>Total Cost</p>
//                         <p className="text-right">Rs xx</p>
//                       </div>
//                       <p className="text-[13px] tracking-[0.25em] mt-8 2xl:ml-[18vh] xl:ml-[35vh] lg:ml-60">
//                         Rs&nbsp;xx
//                         <br />
//                         per&nbsp;person
//                       </p>
//                       <p className="text-[13px] tracking-[0.25em] mt-20 2xl:ml-[18vh] xl:ml-[35vh] lg:ml-60">
//                         <a
//                           href="/Details"
//                           className="uppercase tracking-[0.25em] text-[12px] hover:font-bold underline decoration-[#948A78] underline-offset-[10px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
//                         >
//                           Book&nbsp;Now
//                         </a>
//                       </p>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="block lg:hidden text-left px-8">
//                   <p className="text-[#948A78] text-[20px] mb-6 sm:ml-[8vw] -ml-12">
//                     Pricing <br /> Details
//                   </p>
//                   <div className="text-[13px] tracking-[0.2em] text-[#948A78] space-y-4 ">
//                     <div className="grid grid-cols-2 w-full max-w-xs mx-auto">
//                       <p>Rs xx X 1 night</p>
//                       <p className="text-right">Rs xx</p>
//                     </div>
//                     <div className="grid grid-cols-2 w-full max-w-xs mx-auto">
//                       <p>GST @ 12%</p>
//                       <p className="text-right">Rs xx</p>
//                     </div>
//                     <div className="grid grid-cols-2 w-full max-w-xs mx-auto">
//                       <p>Convenience Fee</p>
//                       <p className="text-right">Rs xx</p>
//                     </div>
//                     <div className="pt-6">
//                       <div className="grid grid-cols-2 w-full max-w-xs mx-auto uppercase font-bold tracking-[0.3em]">
//                         <p>Total Cost</p>
//                         <p className="text-right">Rs xx</p>
//                       </div>
//                       <div className="grid grid-cols-2 w-full max-w-xs mx-auto mt-8 sm:ml-48 ml-10">
//                         <div />
//                         <p className="justify-self-end text-[13px] tracking-[0.25em] text-[#948A78]">
//                           Rs&nbsp;xx
//                           <br />
//                           per&nbsp;person
//                         </p>
//                         <div />
//                         <p className="justify-self-end text-[13px] tracking-[0.25em] text-[#948A78] mt-20">
//                           <a
//                             href="/Details"
//                             className="uppercase tracking-[0.25em] text-[12px] hover:font-bold underline decoration-[#948A78] underline-offset-[10px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
//                           >
//                             Book&nbsp;Now
//                           </a>
//                         </p>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <NewFooter />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BookNow;
